export default __webpack_public_path__ + "static/media/happyman.e67bce69.jpg";